<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Permitted Member Groups</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="groupId" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.groupId }}</td>
        <td class="text-xs-left">{{ props.item.groupDesc }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" remove @remove="doPromptRemove(props.item)" :loading="loading"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-card-text>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()">
        Permit Member Group
        <v-icon right>mdi-account-card-details</v-icon>
      </v-btn>
    </v-card-text>
    <v-dialog v-model="addMemberGroupDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Permit Member Group for Promotion</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete :label="labels.groupId" v-model="promoMemberGrpForm.groupId" :items="memberGroupList" item-text="label" item-value="value" :error-messages="errors.collect('groupId')" data-vv-name="groupId" :data-vv-as="labels.groupId" v-validate="'required'" :loading="groupIdLoading"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Member Group?
      <div class="title">{{deletePromoMemberGrp}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      headers: [
        { text: 'Group ID', align: 'left', value: 'groupId', sortable: false },
        { text: 'Group Description', align: 'left', value: 'groupDesc', sortable: false },
        TableConst.tableActionHeader
      ],
      labels: {
        groupId: 'Member Group*'
      },
      promoMemberGrpForm: {
        promotion: undefined,
        groupId: undefined
      },
      totalItems: 0,
      loading: false,
      items: [],
      groupIdLoading: false,
      memberGroupList: [],
      addMemberGroupDialog: false,
      promptRemove: false,
      selectedPromoMemberGrp: undefined,
      deletePromoMemberGrp: ''
    }
  },
  methods: {
    async doInit() {
      this.promoMemberGrpForm.promotion = this.promotion
      await this.queryPromotionMemberGroups()
    },
    async queryPromotionMemberGroups() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionMemberGroups
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            promotion: this.promotion
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((promotionMemberGroup) => {
                const convertPromotionMemberGroup = {
                  promotion: promotionMemberGroup.promotion,
                  promotionDesc: promotionMemberGroup.promotionDesc,
                  groupId: promotionMemberGroup.groupId,
                  groupDesc: promotionMemberGroup.groupDesc
                }
                this.items.push(convertPromotionMemberGroup)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getMemberGroupList() {
      this.groupIdLoading = true
      if (this.$store.state.promotionManagement.promotion.memberGroupList && this.$store.state.promotionManagement.promotion.memberGroupList.length > 0) {
        let result = []
        result = this.$store.state.promotionManagement.promotion.memberGroupList
        // Remove those that already permitted
        result = result.filter(memberGroup => {
          for (let permittedMemberGroup of this.items) {
            if (permittedMemberGroup.groupId === memberGroup.value) {
              return false
            }
          }
          return true
        })
        this.memberGroupList = result
      } else {
        this.memberGroupList = []
      }
      this.groupIdLoading = false
    },
    doSave() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doCreate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNew() {
      this.resetMessages()
      this.promoMemberGrpForm.groupId = undefined
      this.addMemberGroupDialog = true
      this.getMemberGroupList()
    },
    async doCreate() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionMemberGroupCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.promoMemberGrpForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            this.doClose()
            // Fetch list again
            this.queryPromotionMemberGroups()
          }
          this.submitting = false
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doClose() {
      this.resetMessages()
      this.promoMemberGrpForm.groupId = undefined
      this.addMemberGroupDialog = false
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedPromoMemberGrp = data
        this.deletePromoMemberGrp = data.groupId + ' - ' + data.groupDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionMemberGroupDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          promotion: this.promotion,
          groupId: this.selectedPromoMemberGrp.groupId
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.queryPromotionMemberGroups()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
